import {Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from "@angular/core";
import {IrbEditorComponent} from "@irb/irb-editors/irb-editors.com";
import {
    IPortfolioResultPFSECRebal,
    IPortfolioResultResponse,
    SecurityTradeActionNote
} from "@irb/irb-editors/editor-portfolio-result/editor-portfolio-result.model";
import {ComPrAllocationsGridLayoutService} from "@irb/irb-editors/editor-portfolio-result/com-pr-allocations-legacy/com-pr-allocations.grid-layout.service";
import {PrAllocationsService} from "@irb/irb-editors/editor-portfolio-result/services";
import {IDropdownItem} from '@irb-common/models/dropdown.model';
import {CellClickedEvent, ProcessCellForExportParams} from 'ag-grid-community';
import {DialogComponent} from '@irb-common/components/dialog/dialog.component';
import {SecurityComponentsDialogComponent} from '@irb/irb-editors/editor-security/security-components-dialog/security-components-dialog.component';
import {IrbAppEvents} from '@irb/app.events';
import {IAlertDialogData} from '@irb/app.model';
import {IrbDialogsEvents} from '@irb/irb-dialogs/irb-dialogs.events';
import {DropdownFilterComponent} from "@irb-common/components/dropdown-filter/dropdown-filter.component";
import {IEvent} from "@irb-common/events";
import {IrbSettingsService} from "@irb/irb-settings/irb-settings.service";

@Component({ 
    standalone: false,
    selector: "irb-com-pr-allocations-legacy",
    templateUrl: "./com-pr-allocations-legacy.component.html",
    styleUrls: ["./com-pr-allocations-legacy.component.scss"]
})
export class ComPrAllocationsLegacyComponent extends IrbEditorComponent implements OnInit {
    @ViewChild("groupDropdown") groupDropdown: any;
    @ViewChild('comPrAllocationTemplate') comPrAllocationTemplate: TemplateRef<any>;
    @ViewChild('securityTradeActionNoteTemplate') securityTradeActionNoteTemplate: TemplateRef<any>;
    @ViewChild("dialogPrComAlloc") dialogPrComAlloc: DialogComponent;

    _data: IPortfolioResultResponse;
    snapShotData: IPortfolioResultResponse;
    @Output() change = new EventEmitter<boolean>();
    grid: any;
    gridOptions: any;
    frameworkComponents: any;
    domLayout: any = 'autoHeight';
    columnMode: string;
    groupOption: IDropdownItem;
    groupOptions: Array<IDropdownItem>;
    gridHeight = '700px';
    comPrAllocationTemplateContent: string;
    securityTradeActionNoteTemplateContent: string;
    componentName: any ='portfolioResultSummaryAllocations-Ungrouped';
    isUnitTest = false;
    popupParent:any;
    constructor(private gls: ComPrAllocationsGridLayoutService, public pralloc: PrAllocationsService, public iss: IrbSettingsService,) {
        super();
        this.popupParent = document.querySelector("body");
        this.columnMode = this.as.getFromSession("PRD_ALLOCATIONS_COLUMN_MODE") || "secDolrVariance";
        this.pralloc.showEquivalents = false;
        this.pralloc.group = this.as.getFromSession("PRD_ALLOCATIONS_GROUP") || "ungroupedAllocLabel";
        this.pralloc.showExcluded = this.as.getFromSession("PRD_ALLOCATIONS_SHOW_EXCLUDED") || false;

        this.gridOptions = {
            columnDefs: this.gls.getColumnDefs(this),
            aggFuncs: this.gls.getAggFuncs(this),
            floatingFilter: false,
            context: {componentParent: this},
            isExternalFilterPresent: () => true,
            doesExternalFilterPass: this.filterGrid.bind(this),
            autoGroupColumnDef: this.gls.getAutoGroupColumnDef(this),
            suppressAggFuncInHeader: true,
            onRowGroupOpened: () => this.updateGridLayout(),
            processCellForClipboard: this.processCellForClipboard.bind(this),
            postSortRows: this.onPostSort.bind(this),
            onCellClicked:  this.onPrAllocationsCellClicked.bind(this),
            suppressHorizontalScroll: true
        } as any;

        this.frameworkComponents = this.gls.getFrameworkComponents();
    }

    @Input()
    get data(): any {
        return this._data;
    }

    set data(d: any) {
        if (d.secRebalDTOList && d.secRebalDTOList.length !== 0 && d.pfSecRebalDTOList && d.pfSecRebalDTOList.length !== 0) {
            const groupSecurities = d.secRebalDTOList.filter((x: any) => x.rebalCompSecurityDTOList.length !== 0);
            if (groupSecurities && groupSecurities.length !== 0) {
                groupSecurities.forEach((grSec: any) => {
                    for (let i = 0; i < d.pfSecRebalDTOList.length; i++) {
                        if (grSec.securityId === d.pfSecRebalDTOList[i].secId) {
                            d.pfSecRebalDTOList[i].rebalCompSecurityDTOList = grSec.rebalCompSecurityDTOList;
                            break;
                        }
                    }
                });
            }
        }
        this._data = d;
    }

    ngOnInit() {
        super.ngOnInit();

        this.checkForEquivalents();
        this.gridOptions.columnDefs = this.gls.getColumnDefs(this);
        this.gridOptions.groupRemoveSingleChildren = this.pralloc.group === 'ungroupedAllocLabel' && this.pralloc.showEquivalents;
        
        this.groupOptions = [
            {name: "Position", value: "ungroupedAllocLabel"},
            {name: "Security Type", value: "SecCustTypeAllocLabel"},
            {name: this.data.envGlobalSettingsDTO.securityCustAttrAbbr, value: "SecCustCatAllocLabel"}
        ];

        this.groupOptions.forEach((item: any) => {
            if (item.value === this.pralloc.group) {
                this.groupOption = item;
            }
        });

        this.componentName = (this.pralloc.showEquivalents) ? "portfolioResultSummaryAllocations-Grouped" : "portfolioResultSummaryAllocations-Ungrouped";
        this.change.emit(true);
    }

    processEvent(event: IEvent): void {
        super.processEvent(event);

        switch (event.type) {
            case IrbAppEvents.GRID_REFRESH:
                this.updateGroupDropdown();
                break;
        }
    }

    onDataChange() {
        this.update();
    }

    updateGroupDropdown() {
        this.iss.getGlobalSettings().subscribe((globalSettings: any) => {
            this.groupOptions = [
                {name: "Position", value: "ungroupedAllocLabel"},
                {name: "Security Type", value: "SecCustTypeAllocLabel"},
                {name: globalSettings.securityCustAttrAbbr, value: "SecCustCatAllocLabel"}
            ];

            this.groupOptions.forEach((item: any) => {
                if (item.value === this.pralloc.group) {
                    this.groupOption = item;
                }
            });
        });;
    }

    update() {
        if (this.grid && !this.util.compare(this.data, this.snapShotData)) {
            this.grid.api.setGridOption('rowData', this.data.pfSecRebalDTOList);
            this.grid.api.refreshHeader();
            this.grid.api.refreshClientSideRowModel('aggregate');
            this.updateGridFooter();
            this.updateGridLayout();
            this.updateSnapShotData();
        }
    }

    onDataLoad() {
        super.onDataLoad();
        this.update();
    }

    updateSnapShotData() {
        this.snapShotData = this.util.clone(this.data);
    }

    onGridReady(params: any) {
        this.grid = params;

        this.grid.api.setGridOption('autoGroupColumnDef',this.gls.getAutoGroupColumnDef(this));
        this.updateGridFooter();
        this.updateGridLayout();
    }

    updateGridLayout() {
        if (this.grid && this.grid.api) {
            const rows = this.grid.api.getDisplayedRowCount() + this.grid.api.getPinnedBottomRowCount();
            this.domLayout = rows > 20 || rows < 2? 'normal' : 'autoHeight';
            if(rows< 2) {
                this.gridHeight = '150px';
            } else if (rows > 20 ) {
                this.gridHeight = '700px';
            } else {
                this.gridHeight = '100%';
            }

            this.grid.api.setGridOption('domLayout', this.domLayout);
        }
    }

    isAllInRange(paramKey: string) {
        let inRangeCount = 0, p: string;;
        const items: Array<IPortfolioResultPFSECRebal> = this.pralloc.getFilteredItems(this.data);

        items.forEach((r: IPortfolioResultPFSECRebal) => {
            if(this.pralloc.showEquivalents && r.isEquivalentParent) {
                if(paramKey == "isWithinRangeBefore") {
                    p = "isEquivalentParentWithinRangeBefore";
                } else if(paramKey == "isWithinRangeAfter") {
                    p = "isEquivalentParentWithinRangeAfter";
                }
            } else {
                p = paramKey;
            }

            if (this.util.getObjectValue(r, p)) {
                inRangeCount++;
            }
        });

        return inRangeCount === items.length;
    }

    getInRangeCount(paramKey: string) {
        let inRangeCount = 0, p: string;
        const items: Array<IPortfolioResultPFSECRebal> = this.pralloc.getFilteredItems(this.data);

        items.forEach((r: IPortfolioResultPFSECRebal) => {
            if(this.pralloc.showEquivalents && r.isEquivalentParent) {
                if(paramKey == "isWithinRangeBefore") {
                    p = "isEquivalentParentWithinRangeBefore";
                } else if(paramKey == "isWithinRangeAfter") {
                    p = "isEquivalentParentWithinRangeAfter";
                }
            } else {
                p = paramKey;
            }

            if (this.util.getObjectValue(r, p)) {
                inRangeCount++;
            }
        });

        return inRangeCount + " of " + items.length;
    }

    updateGridFooter() {
        const footerData: Partial<IPortfolioResultPFSECRebal> = {
            secSymb: 'Portfolio Total',
            secModelTargetPercnt: 0,
            secMktVal: this.data.mktVal,
            secCurPercntVal: 0,
            secMktValAfterAdj: 0,
            secPercntValAfterAdj: 0
        };

        const exclusionFooterData: Partial<IPortfolioResultPFSECRebal> = {
            secSymb: 'with Exclusions',
            secMktVal: this.data.mktValWithXcludedPosns,
            secMktValAfterAdj: this.data.mktValWithXcludedPosnsAfterAdj
        };

        this.data.pfSecRebalDTOList.forEach((r: IPortfolioResultPFSECRebal) => {
            if (!r.secExclusionType && !r.isEquivalentChild) {
                footerData.secModelTargetPercnt += r.secModelTargetPercnt;
                footerData.secCurPercntVal += r.secCurPercntVal;
                footerData.secMktValAfterAdj += r.secMktValAfterAdj;
                footerData.secPercntValAfterAdj += r.secPercntValAfterAdj;
            }
        });

        this.grid.api.setGridOption('pinnedBottomRowData',this.data.isAllocationExcludedPositionRecordsPresent ? [footerData, exclusionFooterData] : [footerData]);
    }

    setColumnMode(m: string) {
        this.columnMode = m;this.as.setToSession("PRD_ALLOCATIONS_COLUMN_MODE", this.columnMode);
        this.grid.api.setGridOption('columnDefs', this.gls.getColumnDefs(this));
    }

    setShowExcluded() {
        this.change.emit(true);
        this.grid.api.onFilterChanged();
        this.as.setToSession("PRD_ALLOCATIONS_SHOW_EXCLUDED", this.pralloc.showExcluded);
        this.updateGridLayout();
    }

    setShowEquivalents() {
        this.componentName = (this.pralloc.showEquivalents) ? "portfolioResultSummaryAllocations-Grouped" : "portfolioResultSummaryAllocations-Ungrouped";
        this.gridOptions.groupRemoveSingleChildren = this.pralloc.group === 'ungroupedAllocLabel' && this.pralloc.showEquivalents;
        this.grid.api.setGridOption('columnDefs', this.gls.getColumnDefs(this));
        this.grid.api.onFilterChanged();
        this.change.emit(true);
        this.updateGridLayout();
        this.grid.api.redrawRows();
    }

    setGroup() {
        this.pralloc.group = this.groupOption.value;
        this.grid.api.setGridOption('columnDefs', this.gls.getColumnDefs(this));
        this.gridOptions.groupRemoveSingleChildren = this.pralloc.group === 'ungroupedAllocLabel' && this.pralloc.showEquivalents;
        this.grid.api.setGridOption("autoGroupColumnDef",this.gls.getAutoGroupColumnDef(this));
        this.grid.api.onFilterChanged();
        this.as.setToSession("PRD_ALLOCATIONS_GROUP", this.pralloc.group);
        this.updateGridLayout();
        this.grid.api.redrawRows();
    }

    filterGrid(node: any) {
        let f = true;

        if (!this.pralloc.showExcluded) {
            f = f && !node.data.secExclusionType;
        }

        if (this.pralloc.showEquivalents && this.pralloc.group === 'ungroupedAllocLabel') {
            f = f && !(node.data.isEquivalent && !node.data.isEquivalentChild);
        } else {
            f = f && !node.data.isEquivalentChild;
        }

        return f;
    }

    getItemsForGroup(searchStr: any) {
        this.groupDropdown.set(DropdownFilterComponent.getFilteredList(searchStr,this.groupOptions));
    }

    processCellForClipboard(params: ProcessCellForExportParams): any {
        return this.gls.isValueDisplaySuppressed(params.column.getColDef().field, params.node.data) ? undefined :
            typeof params.value === 'object' ? params.value.fieldValue : params.value;
    }

    private checkForEquivalents() {
        let equivalentsExists: boolean = false;
        if (this.data && this.data.pfSecRebalDTOList && this.data.pfSecRebalDTOList.length !== 0) {
            this.data.pfSecRebalDTOList.forEach((alloc: IPortfolioResultPFSECRebal) => {
                if (alloc.childEqvList && alloc.childEqvList.length !== 0) {
                    equivalentsExists = true;
                }
            });
        }
        this.pralloc.showEquivalents = equivalentsExists;
    }
    
    getAllocationDescription(params: any) {
        let d: string = '';

        if(params.data) {
            if(!params.data.secType || params.data.secType === "OPTION") {
                return null;
            }

            d = params.data.secSymb + "<br/>" + params.data.secDescription;
        } else {
            d = params.value || '';
        }

        this.comPrAllocationTemplateContent = d;
        return this.comPrAllocationTemplate;
    }

    getSecurityTradeActionNoteTemplate(n: Array<SecurityTradeActionNote>) {
        this.securityTradeActionNoteTemplateContent = "";
        
        n.forEach((note: SecurityTradeActionNote) => {
            this.securityTradeActionNoteTemplateContent += "<div class='block'>" + note.description + "</div>";
        });

        return (n.length > 0) ? this.securityTradeActionNoteTemplate : null;
    }

    showModelHistoryInRebalance() {
        let dialogData = {
            portfolioResultData: this.data
        }
        this.as.fireEvent(IrbDialogsEvents.SHOW_MODEL_USED_IN_REBALANCE_DIALOG, dialogData);
    }

    onPostSort(rowNodes: Array<any>) {
        const optionOrders: any = {};

        //remove option orders, and create a map of options using parent symbol
        for(let i = 0; i < rowNodes.length; i++) {
            if(rowNodes[i].data?.secType === "OPTION") {
                const parentSymbol = rowNodes[i].data.secSymb.split(" ")[0];

                if(typeof optionOrders[parentSymbol] === "undefined") {
                    optionOrders[parentSymbol] = [];
                }

                optionOrders[parentSymbol].push(rowNodes.splice(i--,1)[0]);
            }
        }

        //insert option orders after their parent symbol
        Object.keys(optionOrders).forEach((parentSymbol: string) => {
            for(let i = 0; i < rowNodes.length; i++) {
                if(rowNodes[i].data?.secSymb === parentSymbol) {
                    rowNodes.splice(i + 1, 0, ...optionOrders[parentSymbol]);
                    delete optionOrders[parentSymbol];
                    break;
                }
            }
        });

        //if no parent symbol is found, reinsert
        Object.keys(optionOrders).forEach((parentSymbol: string) => {
            rowNodes.push(...optionOrders[parentSymbol]);
        });
    }

    showGroupComponents(params: any) {
        if (params.data.rebalCompSecurityDTOList.length === 0) {
            this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
                dTitle: "Alert",
                msg: "There are no component securities associated with this group.",
                dProceedBtnLabel: "Ok",
                dType: "ERROR"
            } as IAlertDialogData);
            return;
        }

        const config = this.dialogPrComAlloc.getDefaultConfig();
        config.minHeight = "200px";
        config.height = "auto";
        config.width = "600px";
        config.data = {
            groupSecurity: params.data.secSymb,
            rebalCompSecurityDTOList: params.data.rebalCompSecurityDTOList
        };
        this.dialogPrComAlloc.open(SecurityComponentsDialogComponent, config);
    }

    resetGridColumns() {
        localStorage.removeItem(this.componentName);
        this.grid.api.resetColumnState();
        this.grid.api.applyColumnState({state: null });
        this.setGroup();
        this.setColumnMode(this.columnMode);
        if(this.data.isAllocationExcludedPositionRecordsPresent) {
            this.setShowExcluded();
        }
        //this.grid.api.sizeColumnsToFit();
    }

    onPrAllocationsCellClicked(event: CellClickedEvent) {
        if(event.column.getColId() === 'ag-Grid-AutoColumn' && (
            event.column.getColDef().headerName === 'Allocation')  ) {
            if(event.node.isExpandable() && event.node.expanded) {
                event.node.setExpanded(false);
            } else if (event.node.isExpandable() && !event.node.expanded) {
                event.node.setExpanded(true);
            }
            this.updateGridLayout();
        }
    }
}
